import { render, staticRenderFns } from "./Step3OrderSummary.vue?vue&type=template&id=2fba6351&scoped=true&"
import script from "./Step3OrderSummary.vue?vue&type=script&lang=js&"
export * from "./Step3OrderSummary.vue?vue&type=script&lang=js&"
import style0 from "./Step3OrderSummary.vue?vue&type=style&index=0&id=2fba6351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba6351",
  null
  
)

export default component.exports